/* deboer global behaviors — scroll reveal for .deboer-reveal elements.
   Ported from concept index.html. Idempotent + handles sections
   injected by the theme editor (Shopify section load events). */
(function () {
  // User-facing strings come from theme.liquid (window.deboerStrings, rendered
  // with | t) so they translate; every read falls back to English.
  var S = window.deboerStrings || {};

  // Analytics sink: deboer.track() → Shopify.analytics.publish (Customer Events).
  // A Custom Web Pixel subscribes store-side; with no pixel configured every
  // call is a safe no-op. This revives the deboer.track() call sites in the
  // sections and the declarative data-track / data-track-view hooks.
  function track(name, payload) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload || {});
      }
    } catch (e) {}
  }
  window.deboer = window.deboer || {};
  window.deboer.track = track;

  // Locale safety net. Known link sites localize server-side via the 'lurl'
  // snippet, but JS-built markup and app-injected anchors can still carry
  // unprefixed root-relative hrefs, which drop the visitor out of /es-es etc.
  // Rewrite the href at (aux)click time, before the browser follows it.
  function localizeHref(e) {
    var root = window.routes && window.routes.root_url;
    if (!root || root === '/') return;
    var a = e.target && e.target.closest ? e.target.closest('a[href^="/"]') : null;
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(1) === '/') return;
    if (href === root || href.indexOf(root + '/') === 0 || href.indexOf(root + '?') === 0 || href.indexOf(root + '#') === 0) return;
    a.setAttribute('href', href === '/' ? root : root + href);
  }
  document.addEventListener('click', localizeHref, true);
  document.addEventListener('auxclick', localizeHref, true);
  // Exposed for dynamically injected content (e.g. the PDP fit switcher swaps
  // in a fresh <product-info>): re-runs reveals + notify/tracking wiring.
  window.deboer.init = function (scope) { init(scope); };

  // Ops beacons (rev 8): fire-and-forget reports to the status-monitor worker —
  // the theme's only external calls. Deliberately incapable of affecting the
  // page: nothing awaited, responses ignored, everything swallowed; if the
  // monitor is down these are silent no-ops.
  var MONITOR = 'https://deboer-status-monitor.deboerswim.workers.dev';
  function beacon(path, payload) {
    try {
      var body = JSON.stringify(payload || {});
      if (navigator.sendBeacon && navigator.sendBeacon(MONITOR + path, body)) return;
      fetch(MONITOR + path, { method: 'POST', body: body, mode: 'no-cors', keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  window.deboer.beacon = beacon;

  // Sampled pageview beacon (20%): external-referrer landings only, so the
  // status monitor can chart top referrers. Fire-and-forget like everything above.
  try {
    var ref = document.referrer;
    if (ref) {
      var refHost = new URL(ref).hostname;
      if (refHost && refHost !== location.hostname && Math.random() < 0.2) {
        beacon('/beacon/pageview', { path: location.pathname.slice(0, 200), referrer: ref.slice(0, 200) });
      }
    }
  } catch (e) {}

  // Form-submission pings (rev 9): at submit time, stash a safe summary of any
  // Shopify form post (action /contact — contact forms + newsletter); when the
  // platform confirms the post on the return page (?contact_posted=true /
  // ?customer_posted=true) beacon it to the monitor, which relays to Slack
  // (#deboer-forms). Confirmed-only, so bots that fail Shopify's own bot check
  // never ping; the stash expires after 15 minutes. Sections can label their
  // form with data-form-name="proam-application" etc; unlabeled forms fall
  // back to the page handle.
  try {
    var FORM_STASH = 'deboer_form_pending';
    document.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        if (!f || !f.action || String(f.method).toLowerCase() !== 'post') return;
        if (String(f.action).indexOf('/contact') === -1) return;
        var fd = new FormData(f);
        var formType = String(fd.get('form_type') || 'contact');
        var fields = {};
        var count = 0;
        fd.forEach(function (v, k) {
          var m = /^contact\[(.+)\]$/.exec(k);
          // ProAm application only: 40 fields / 1200 chars — ~26 fields with
          // long answers, filed to the director's Google Sheet by the monitor.
          // Every other form (incl. the Nitro portal claim) keeps 12 / 300.
          var isProam = f.getAttribute('data-form-name') === 'proam-application';
          if (!m || count >= (isProam ? 40 : 12)) return;
          var val = String(v).trim();
          if (!val) return;
          var key = m[1] === 'body' ? 'Message' : m[1];
          fields[key.slice(0, 40)] = val.slice(0, isProam ? 1200 : 300);
          count++;
        });
        if (!count) return;
        // quizTagBridge() registers its own capture-phase submit listener, but it
        // does so from initOnce() — after this one. Same target, same phase, so
        // registration order decides, and this handler snapshots contact[tags]
        // BEFORE the bridge appends quiz:<discipline>-<gender>-<q3>. Shopify then
        // stores the full tag while the beacon ships only fit:/fit-size:, and the
        // monitor's `quiz.split("-")[1]` reads undefined and defaults GENDER to
        // "m" — which sent every woman who finished the fit guide to the men's
        // PDP (4 of 13 live contacts on 2026-09-01). Recompute here so the beacon
        // does not depend on listener order.
        if (typeof fields.tags === 'string') {
          try { fields.tags = leadTags(fields.tags, fitState(), audState().aud).value; } catch (e) {}
        }
        var slug = f.getAttribute('data-form-name') ||
          (formType === 'customer' ? 'newsletter'
            : fields['Discipline'] ? 'proam-application'
            : (location.pathname.replace(/^\/(pages|blogs)\//, '').replace(/[^\w-]+/g, '-') || 'contact'));
        sessionStorage.setItem(FORM_STASH, JSON.stringify({
          form: slug,
          page: location.pathname.slice(0, 200),
          host: location.hostname,
          fields: fields,
          t: Date.now()
        }));
      } catch (err) {}
    }, true);
    if (location.search.indexOf('contact_posted=true') !== -1 || location.search.indexOf('customer_posted=true') !== -1) {
      var pendingForm = sessionStorage.getItem(FORM_STASH);
      if (pendingForm) {
        sessionStorage.removeItem(FORM_STASH);
        var pf = JSON.parse(pendingForm);
        if (Date.now() - (pf.t || 0) < 15 * 60000) {
          delete pf.t;
          beacon('/beacon/form', pf);
        }
      }
    }
  } catch (e) {}

  // Global JS-error reporting: max 5 per page; skips opaque cross-origin
  // "Script error." events and errors from extensions/third-party scripts
  // (own origin, relative, and Shopify CDN sources are ours).
  var errBudget = 5;
  function reportError(message, source, line, col, stack) {
    try {
      if (errBudget <= 0) return;
      message = String(message || '');
      source = String(source || '');
      if (!message || message === 'Script error.') return;
      if (source && source.indexOf(location.origin) !== 0 && source.indexOf('/') !== 0 && source.indexOf('cdn.shopify.com') === -1) return;
      errBudget--;
      beacon('/beacon/js-error', {
        message: message.slice(0, 300),
        source: source.slice(0, 200),
        line: line || 0,
        col: col || 0,
        path: location.pathname.slice(0, 120),
        stack: stack ? String(stack).slice(0, 700) : ''
      });
    } catch (e) {}
  }
  window.addEventListener('error', function (e) {
    if (e && e.message) reportError(e.message, e.filename, e.lineno, e.colno, e.error && e.error.stack);
  });
  // A rejected fetch carries no stack, so `source` comes out empty and the
  // same-origin filter in reportError can't do its job — `if (source && ...)`
  // lets anything unattributable straight through. That is how 118 "Load failed"
  // in a week reached the error feed: ad-blocked pixels and dropped mobile
  // connections, none of it our code, drowning the real errors and firing the
  // spike thresholds. Drop the known network-failure messages when there is
  // nothing to attribute them to; anything naming real code still reports.
  var NET_NOISE = /^(load failed|failed to fetch|networkerror.*|the operation was aborted\.?|the network connection was lost\.?|cancelled|aborted)$/i;
  window.addEventListener('unhandledrejection', function (e) {
    var r = e && e.reason;
    var msg = r && r.message ? r.message : String(r);
    var src = r && r.stack ? String(r.stack).split('\n')[1] || '' : '';
    if (!src && NET_NOISE.test(String(msg).trim())) return;
    reportError('Unhandled rejection: ' + msg, src, 0, 0, r && r.stack);
  });

  // Accessible dialog helper (rev 7): role/aria wiring, focus trap, Esc close,
  // focus restore to the invoker. Sections call deboer.dialog.open(panel, { onClose })
  // with the visible card element; the overlay show/hide stays theirs.
  var dlgStack = [];
  function dlgFocusables(el) {
    return [].slice.call(el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (n) { return n.getClientRects().length > 0; });
  }
  window.deboer.dialog = {
    open: function (el, opts) {
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      var rec = {
        el: el, invoker: document.activeElement, onClose: opts && opts.onClose,
        key: function (e) {
          if (e.key === 'Escape') { e.stopPropagation(); window.deboer.dialog.close(el); return; }
          if (e.key !== 'Tab') return;
          var f = dlgFocusables(el);
          if (!f.length) { e.preventDefault(); el.focus(); return; }
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && (document.activeElement === first || !el.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && (document.activeElement === last || !el.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
        }
      };
      dlgStack.push(rec);
      document.addEventListener('keydown', rec.key, true);
      var doFocus = function () { var f = dlgFocusables(el); (f[0] || el).focus(); };
      doFocus();
      // dialogs that fade/display-toggle in aren't focusable at open() time — retry once painted
      setTimeout(function () { if (!el.contains(document.activeElement)) doFocus(); }, 80);
    },
    close: function (el) {
      for (var i = dlgStack.length - 1; i >= 0; i--) {
        if (dlgStack[i].el === el) {
          var rec = dlgStack.splice(i, 1)[0];
          document.removeEventListener('keydown', rec.key, true);
          if (rec.onClose) rec.onClose();
          if (rec.invoker && rec.invoker.focus) rec.invoker.focus();
          return;
        }
      }
    }
  };

  // Polite screen-reader announcer for dynamic swaps (fit switcher, waitlist, quiz).
  var liveNode = null;
  window.deboer.announce = function (msg) {
    if (!liveNode) {
      liveNode = document.createElement('div');
      liveNode.setAttribute('aria-live', 'polite');
      liveNode.setAttribute('role', 'status');
      liveNode.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
      document.body.appendChild(liveNode);
    }
    liveNode.textContent = '';
    setTimeout(function () { liveNode.textContent = msg; }, 30);
  };

  function trackPayload(el) {
    var p = {};
    [].slice.call(el.attributes).forEach(function (a) {
      if (a.name.indexOf('data-track-') === 0 && a.name !== 'data-track-view') {
        p[a.name.slice(11).replace(/-/g, '_')] = a.value;
      }
    });
    return p;
  }
  function wireTracking(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-track-view]:not([data-tracked])')).forEach(function (el) {
      el.setAttribute('data-tracked', '1');
      track(el.getAttribute('data-track-view') + '_view', trackPayload(el));
    });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-track]');
    if (el) track(el.getAttribute('data-track'), trackPayload(el));
  }, true);
  // Forms opt in via data-deboer-event (waitlist capture, newsletter capture).
  // Every data-deboer-* attribute rides along as an event param, so the
  // waitlist can report WHICH size died and whether the whole product is gone —
  // "sold out in every size" and "my size is gone" were indistinguishable in
  // GA4 before, and they call for completely different responses.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    var ev = f.getAttribute && f.getAttribute('data-deboer-event');
    if (!ev) return;
    var p = {};
    [].slice.call(f.attributes).forEach(function (a) {
      if (a.name.indexOf('data-deboer-') !== 0 || a.name === 'data-deboer-event') return;
      if (!a.value) return;
      p[a.name.slice(12).replace(/-/g, '_')] = a.value;
    });
    track(ev, p);
  }, true);
  function revealAll(scope) {
    var els = (scope || document).querySelectorAll('.deboer-reveal:not(.in)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
      // threshold 0, not a fraction: a percentage threshold is unsatisfiable for
      // any block taller than 1/threshold viewports, because it can never be that
      // much visible at once. At 0.1 the 15-athlete roster grid on /pages/athletes
      // (10437px in an 844px viewport, max 7.4% visible) never fired and the whole
      // page stayed at opacity 0 on mobile. rootMargin already delays the trigger.
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });

    // Safety net, mirroring revAll() below. Threshold 0 covers ordinary scrolling,
    // but a jump straight down the page — browser scroll restore on back-nav, or an
    // in-page anchor — can outrun the observer and leave a block hidden (measured
    // 6/8 on /pages/athletes at 390px). Sweep anything already scrolled into or
    // past view: on a short timer, and once on first scroll.
    var sweep = function () {
      var left = 0;
      els.forEach(function (e) {
        if (e.classList.contains('in')) return;
        if (e.getBoundingClientRect().top < (window.innerHeight || 800) * 1.1) {
          e.classList.add('in'); io.unobserve(e);
        } else { left++; }
      });
      return left;
    };
    setTimeout(sweep, 900);
    var onScroll = function () {
      if (sweep() === 0) window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Opt-in [data-rev] reveal (concept (5) motion pass). Mirrors .deboer-reveal
  // but staggers via the numeric value (data-rev="2" => +90ms, etc.). CSS gates
  // the initial hidden state behind .js-rev so no-JS users always see content.
  function revAll(scope) {
    var root = scope || document;
    var revEls = [].slice.call(root.querySelectorAll('[data-rev]:not(.is-in)'));
    if (!revEls.length) return;
    // No-JS / reduced-motion / no IO / hidden document (background tab, capture
    // context): reveal immediately so content can never be caught mid-hide (rev 6).
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden) {
      revEls.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    document.documentElement.classList.add('js-rev');
    var ioFired = false;
    var io = new IntersectionObserver(function (entries) {
      ioFired = true;
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
      // threshold 0 for the same reason as revealAll above — see the note there.
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    revEls.forEach(function (e) {
      var n = parseInt(e.getAttribute('data-rev'), 10);
      if (n > 1) e.style.transitionDelay = ((n - 1) * 90) + 'ms';
      io.observe(e);
    });
    var revealRemaining = function () { io.disconnect(); revEls.forEach(function (e) { e.classList.add('is-in'); }); };
    // If the document goes hidden (export/capture), drop gating so nothing stays invisible.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { document.documentElement.classList.remove('js-rev'); revealRemaining(); }
    });
    // Safety net: if the observer never delivers, reveal anything already in view (rev 6).
    setTimeout(function () {
      if (!ioFired) { revealRemaining(); return; }
      revEls.forEach(function (e) {
        if (!e.classList.contains('is-in')) {
          var r = e.getBoundingClientRect();
          if (r.top < (window.innerHeight || 800) * 1.1) e.classList.add('is-in');
        }
      });
    }, 900);
  }

  // First-wetsuit (plain-English) mode (rev 6). A .rktog toggle on guide/PDP pages
  // flips body.rookie, which reveals .rk explainer blocks. Persisted in localStorage.
  function rookieMode() {
    try { if (localStorage.getItem('deboer_rookie') === '1') document.body.classList.add('rookie'); } catch (e) {}
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.rktog') : null;
      if (!b) return;
      var on = document.body.classList.toggle('rookie');
      try { localStorage.setItem('deboer_rookie', on ? '1' : '0'); } catch (e2) {}
      track('rookie_mode', { state: on ? 'on' : 'off' });
    });
  }

  // Sold-out notify (concept (5)). Auto-wires any PDP that renders static
  // sized buttons (.size, with .size.out for sold-out). On a sold-out click it
  // inserts a restock-alert email panel after the .sizes group. No-op on PDPs
  // that ship their own notify (#notify) or have no static size buttons.
  function wireNotify(scope) {
    var root = scope || document;
    if (!root.querySelector('.size.out') || root.querySelector('#notify')) return;
    var sizesEl = root.querySelector('.sizes');
    if (!sizesEl) return;
    var np = document.createElement('div');
    np.className = 'notify'; np.id = 'notify'; np.hidden = true;
    np.setAttribute('role', 'status'); // announce panel + join confirmation to SRs
    sizesEl.parentNode.insertBefore(np, sizesEl.nextSibling);
    function showNotify(sz) {
      np.hidden = false;
      np.innerHTML = '<p><b>' + (S.notifySoldOut || 'Size [size] is sold out.').replace('[size]', sz) + '</b> ' +
        (S.notifyBody || 'Leave your email and we’ll let you know the moment it’s back — restock alerts go out before the suit returns to the site.') + '</p>' +
        '<form><input type="email" required placeholder="' + (S.emailPlaceholder || 'you@email.com') + '" aria-label="' + (S.notifyAria || 'Email for restock alert') + '" /><button type="submit">' + (S.notifyButton || 'Notify me') + '</button></form>';
      np.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        track('waitlist_join', { size: sz, source: 'size_buttons' });
        np.innerHTML = '<span class="ok">' + (S.notifySuccess || '✓ You’re on the list — we’ll email you when size [size] is back.').replace('[size]', sz) + '</span>';
      });
    }
    [].slice.call(root.querySelectorAll('.size')).forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.classList.contains('out')) { showNotify(s.textContent); } else { np.hidden = true; }
      });
    });
  }

  // Sold-out panel size chips (design 13a, 2026-08-27). Every size is
  // selectable even though none can be bought: the chosen one rides into the
  // waitlist tag (waitlist-size:<handle>:<size>) so the twelve Tsunami
  // sign-ups stop being indistinguishable and become a production input.
  function wireWaitlistSizes(scope) {
    var root = scope || document;
    [].slice.call(root.querySelectorAll('[data-wl-sizes]')).forEach(function (row) {
      if (row.__wl) return;
      row.__wl = true;
      var panel = row.closest('.inv-cta__notify');
      var form = panel && panel.querySelector('form.inv-cta__form');
      if (!form) return;
      var tagsEl = form.querySelector('input[name="contact[tags]"]');
      var handle = row.getAttribute('data-wl-handle') || '';
      var base = tagsEl ? tagsEl.value.split(',')[0].trim() : ('waitlist:' + handle);
      var btnEl = form.querySelector('button[type="submit"]');
      var btnTpl = row.getAttribute('data-wl-button') || '';
      row.addEventListener('click', function (e) {
        var chip = e.target.closest && e.target.closest('[data-wl-size]');
        if (!chip) return;
        [].slice.call(row.querySelectorAll('[data-wl-size]')).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        var size = chip.getAttribute('data-wl-size');
        var slug = size.toLowerCase().replace(/ \/ /g, '-').replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        if (tagsEl) tagsEl.value = base + ', waitlist-size:' + handle + ':' + slug;
        form.setAttribute('data-deboer-size', size);
        form.setAttribute('data-deboer-scope', 'variant');
        if (btnEl && btnTpl) btnEl.firstChild.textContent = btnTpl.replace('[size]', size) + ' ';
      });
    });
  }

  // Quick-add confirmation (2026-10-23): shopper-sim runs found that after ADD
  // the cart count sits in a header scrolled ~1,600px away and nothing else
  // moves — every tester scrolled back up hunting for the cart. A bar pinned
  // to the bottom edge offers the next step without leaving the grid.
  function qaToast(f, c) {
    var t = document.getElementById('db-qa-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'db-qa-toast'; t.className = 'db-qa-toast'; t.setAttribute('role', 'status');
      t.innerHTML = '<span class="db-qa-toast__msg"></span><a class="db-qa-toast__view"></a><a class="db-qa-toast__go"></a><button type="button" class="db-qa-toast__x" aria-label="Close">&times;</button>';
      document.body.appendChild(t);
      t.querySelector('.db-qa-toast__x').addEventListener('click', function () { t.classList.remove('is-on'); });
    }
    var cartUrl = f.getAttribute('data-cart-url') || '/cart';
    var name = (f.closest('.pcard__wrap, .grid__item, li') || f).querySelector('.pcard__name, .card__heading');
    t.querySelector('.db-qa-toast__msg').textContent = (btnDone(f)) + (name ? ' ' + name.textContent.trim() : '') + ' · ' + c.item_count;
    var v = t.querySelector('.db-qa-toast__view'); v.href = cartUrl; v.textContent = f.getAttribute('data-t-view') || 'View cart';
    var g = t.querySelector('.db-qa-toast__go'); g.href = cartUrl.replace(/\/?$/, '') + '?checkout'; g.textContent = f.getAttribute('data-t-checkout') || 'Check out';
    g.onclick = function (e) { e.preventDefault(); var fm = document.createElement('form'); fm.method = 'post'; fm.action = cartUrl; fm.innerHTML = '<input type="hidden" name="checkout" value="">'; document.body.appendChild(fm); fm.submit(); };
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 8000);
  }
  function btnDone(f) { var b = f.querySelector('button'); return (b && b.getAttribute('data-done')) || 'Added ✓'; }

  // Quick add (idea K, 2026-08-27): grid cards post /cart/add.js in place.
  // Cart bubble updates via the same .db-cart-n counters the gift engine uses.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-quick-add]')) return;
    e.preventDefault();
    var sel = f.querySelector('select[name="id"]'), idEl = sel || f.querySelector('input[name="id"]');
    if (!idEl || !idEl.value) { if (sel) sel.focus(); return; }
    var btn = f.querySelector('button'); btn.disabled = true;
    fetch(f.getAttribute('action') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(idEl.value, 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        f.classList.add('is-done'); btn.textContent = btn.getAttribute('data-done') || 'Added ✓';
        track('quick_add', { item: f.getAttribute('data-handle'), item_list_name: f.getAttribute('data-list') || '', variant: idEl.value, price: parseFloat(f.getAttribute('data-price')) || undefined, page: location.pathname });
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.db-cart-n').forEach(function (n) { n.textContent = c.item_count; });
          qaToast(f, c);
        });
      })
      .catch(function () { btn.disabled = false; })
      .then(function () { setTimeout(function () { btn.disabled = false; f.classList.remove('is-done'); btn.textContent = btn.getAttribute('data-label') || 'Add'; }, 2500); });
  }, true);

  // First-wetsuit router strip (idea J): show per its rule — always, only in
  // rookie mode, or only to visitors with no quiz result / no account.
  function firstSuitRouter(scope) {
    [].slice.call((scope || document).querySelectorAll('[data-fsr]:not([data-fsr-done])')).forEach(function (el) {
      el.setAttribute('data-fsr-done', '1');
      var rule = el.getAttribute('data-fsr'), show = true;
      if (rule === 'rookie') show = document.body.classList.contains('rookie');
      if (rule === 'no_history') {
        var fit = null; try { fit = JSON.parse(localStorage.getItem('deboer_fit') || 'null'); } catch (e) {}
        show = !(fit && fit.done) && el.getAttribute('data-fsr-customer') !== 'true';
      }
      el.hidden = !show;
      if (rule === 'rookie') document.addEventListener('click', function () { setTimeout(function () { el.hidden = !document.body.classList.contains('rookie'); }, 0); }, true);
    });
  }

  // Tells the inline failsafe in theme.liquid that the reveal machinery is
  // alive, so it leaves .js-reveal armed. If this file never runs, the flag is
  // never set, the class is dropped and the page renders unanimated but visible.

  // ---- Size-level product views -------------------------------------------
  // GA4's own view_item reports the product's DEFAULT variant, so the PDP's
  // size dimension was noise: men's fjord 4.0 logged 3,014 views on size S and
  // 47 on M, while M took nearly twice the add-to-carts. Nothing recorded
  // whether the size was even buyable at the moment someone looked at it.
  //
  // The inventory-CTA block carries a hidden data span that product-info.js
  // re-renders on every variant change, so watching it gives the SELECTED size
  // plus its availability. One event per (product, variant) per pageview —
  // flicking back and forth between two sizes is one look at each, not ten.
  var pvSeen = {};
  function firePV(el) {
    if (!el) return;
    var d = el.dataset || {};
    if (!d.pvProduct || !d.pvVariant) return;
    var k = d.pvProduct + ':' + d.pvVariant;
    if (pvSeen[k]) return;
    pvSeen[k] = 1;
    track('product_view', {
      product_id: d.pvProduct,
      handle: d.pvHandle || undefined,
      variant_id: d.pvVariant,
      size: d.pvSize || undefined,
      available: d.pvAvailable === '1' ? 'yes' : 'no',
      inv_state: d.pvState || undefined,
      price: d.pvPrice ? Number(d.pvPrice) : undefined
    });
  }
  function wireProductView(scope) {
    var root = scope || document;
    var holders = [].slice.call(root.querySelectorAll('.inv-cta'));
    // A fit swap replaces the whole <product-info>, so a scoped call can be
    // handed the block itself rather than an ancestor of it.
    if (!holders.length && root.classList && root.classList.contains('inv-cta')) holders = [root];
    holders.forEach(function (h) {
      firePV(h.querySelector('.inv-cta__data'));
      if (h.getAttribute('data-pv-wired')) return;
      h.setAttribute('data-pv-wired', '1');
      if (typeof MutationObserver !== 'function') return;
      // product-info.js swaps innerHTML on variant change; the new data span
      // arrives as a childList mutation.
      new MutationObserver(function () {
        firePV(h.querySelector('.inv-cta__data'));
      }).observe(h, { childList: true });
    });
  }


  // ---- gender signal (2026-08-26) ----------------------------------------
  // One answer to "men's or women's?" for every gendered surface (clearance,
  // collection grids, cart rows, PDP rails). Priority: an explicit pick
  // (localStorage.deboer_gender, persistent) → the fit quiz → the customer's
  // last orders (body[data-gender-bought], Liquid) → what's in the bag
  // ([data-cart-gender]). Surfaces declare [data-gender-scope]; cards inside
  // carry data-gender="men|women|all"; chips are [data-gender-set="men|women|"].
  // data-gender-min="N" keeps a rail from emptying; data-gender-custom scopes
  // do their own hiding and only get chips/copy + a 'deboer:gender' event.
  var gender = (function () {
    var KEY = 'deboer_gender';
    function fromFit() { try { var f = JSON.parse(localStorage.getItem('deboer_fit') || 'null'); return f && (f.gender === 'men' || f.gender === 'women') ? f.gender : ''; } catch (e) { return ''; } }
    function get() {
      var pick = ''; try { pick = localStorage.getItem(KEY) || ''; } catch (e) {}
      if (pick === 'all') return { g: '', src: '' };
      if (pick === 'men' || pick === 'women') return { g: pick, src: S.genderSrcPick || 'you chose' };
      var f = fromFit(); if (f) return { g: f, src: S.genderSrcQuiz || 'from your fit quiz' };
      var b = document.body && document.body.getAttribute('data-gender-bought') || ''; if (b) return { g: b, src: S.genderSrcOrder || 'from your last order' };
      var c = document.querySelector('[data-cart-gender]'); c = c ? c.getAttribute('data-cart-gender') : ''; if (c) return { g: c, src: S.genderSrcBag || "from what's in your bag" };
      return { g: '', src: '' };
    }
    function set(g) { try { localStorage.setItem(KEY, g || 'all'); } catch (e) {} try { track('gender_set', { to: g || 'all' }); } catch (e) {} apply(document); }
    function apply(root) {
      var st = get(); root = root || document;
      var scopes = [].slice.call(root.querySelectorAll('[data-gender-scope]'));
      if (root.getAttribute && root.hasAttribute('data-gender-scope')) scopes.unshift(root);
      scopes.forEach(function (scope) {
        var g = st.g, min = parseInt(scope.getAttribute('data-gender-min') || '0', 10);
        var cards = [].slice.call(scope.querySelectorAll('[data-gender]'));
        var ok = function (c) { var cg = c.getAttribute('data-gender'); return !g || cg === 'all' || cg === g; };
        if (g && min && cards.filter(ok).length < min) g = '';
        if (!scope.hasAttribute('data-gender-custom')) cards.forEach(function (c) { c.hidden = !ok(c); });
        scope.querySelectorAll('[data-gender-set]').forEach(function (b) { b.classList.toggle('is-on', (b.getAttribute('data-gender-set') || '') === g); });
        scope.querySelectorAll('[data-gender-copy]').forEach(function (h) { var v = h.getAttribute('data-' + (g || 'all')); if (v) h.textContent = v; });
        scope.querySelectorAll('[data-gender-src]').forEach(function (x) { x.textContent = g ? st.src : ''; x.hidden = !g || !st.src; });
        try { scope.dispatchEvent(new CustomEvent('deboer:gender', { detail: { g: g, src: st.src } })); } catch (e) {}
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gender-set]'); if (!b || b.tagName === 'A') return;
      e.preventDefault(); set(b.getAttribute('data-gender-set') || 'all');
    });
    // Dawn's <product-recommendations> swaps its innerHTML after a fetch.
    try {
      new MutationObserver(function (ms) { ms.forEach(function (m) { if (m.target.matches && m.target.matches('product-recommendations')) apply(m.target); }); })
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    return { get: get, set: set, apply: apply, fromFit: fromFit };
  })();
  window.deboer.gender = gender;

  function init(scope) {
    try { gender.apply(scope || document); } catch (e) {}
    window.deboer.revealReady = true;
    revealAll(scope); revAll(scope); wireNotify(scope); wireWaitlistSizes(scope); wireTracking(scope); wireProductView(scope); firstSuitRouter(scope);
    // A PDP fit swap calls init(node) with the replaced markup; re-arm the
    // sticky buy bar against the new button. Safe to call repeatedly — it
    // re-observes rather than rebuilding.
    stickyBuy();
  }

  // Resume-your-fit strip (rev 6). Replaces any [data-fit-resume] placeholder with a
  // strip that links the visitor back to their saved fit-quiz progress / result.
  // Reads localStorage.deboer_fit (written by the fit-guide). No-op (and removes the
  // placeholder) when there's no saved fit.
  function escH(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fitResume() {
    var els = [].slice.call(document.querySelectorAll('[data-fit-resume]'));
    if (!els.length) return;
    var sv = null;
    try { sv = JSON.parse(localStorage.getItem('deboer_fit') || 'null'); } catch (e) {}
    var answered = sv ? ['discipline', 'gender', 'q3'].filter(function (k) { return sv[k]; }).length : 0;
    els.forEach(function (el) {
      var d = el.dataset || {};
      var h;
      if (!sv || (!sv.done && answered === 0)) {
        // No quiz on this device. Known customer → welcome back; else the
        // first-time card (designs 10a ⑤ / idea L, 2026-08-27). Sections
        // without the data attributes (older placements) still vanish.
        if (d.custName || d.custSize) {
          var nm = d.custName ? ', ' + d.custName : '';
          h = '<span class="fitres__ey">' + escH(d.backTitle || 'Welcome back[name]').replace('[name]', escH(nm)) + '</span>' +
            '<span class="fitres__t">' + escH((d.backBody || 'Your size [size] · your picks are one tap away.').replace('[size]', d.custSize || '—')) + '</span>' +
            '<a class="deboer-link" href="' + escH(d.backUrl || '/collections/essentials') + '" data-track="welcome_back_click" data-track-source="fit_resume">' + escH(d.backCta || 'Reorder essentials') + ' <span class="ar">&rarr;</span></a>' +
            (d.backAlt ? '<a class="fitres__alt" href="' + escH(d.backAltUrl || '/collections/training') + '">' + escH(d.backAlt) + '</a>' : '');
        } else if (d.firstTitle) {
          h = '<span class="fitres__ey">' + escH(d.firstTitle) + '</span>' +
            '<span class="fitres__t">' + escH(d.firstBody || '') + '</span>' +
            '<a class="deboer-link" href="' + escH(d.firstUrl || '/pages/fit-guide') + '" data-track="select_promotion" data-track-creative="fit_first_time" data-track-slot="fit_resume">' + escH(d.firstCta || 'Take the fit guide') + ' <span class="ar">&rarr;</span></a>' +
            (d.firstNote ? '<span class="fitres__alt fitres__note">' + escH(d.firstNote) + '</span>' : '');
        } else { if (el.parentNode) el.parentNode.removeChild(el); return; }
        var w0 = document.createElement('div'); w0.className = 'fitres fitres--first'; w0.innerHTML = '<div class="fitres__in">' + h + '</div>';
        el.parentNode.replaceChild(w0, el);
        return;
      }
      if (sv.done && sv.result) {
        // Deep-link the recommended size when the quiz saved a variant id.
        var resUrl = sv.result.url + (sv.result.variant ? (sv.result.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + sv.result.variant : '');
        h = '<span class="fitres__ey">' + (S.fitMatch || 'Your fit match') + '</span>' +
          '<span class="fitres__t">' + sv.result.nm + (sv.result.size ? ' · ' + (S.fitSize || 'Size') + ' ' + sv.result.size : '') + ' · ' + sv.result.price + '</span>' +
          '<a class="deboer-link" href="' + resUrl + '">' + (S.fitShop || 'Shop the [name]').replace('[name]', sv.result.nm) + ' <span class="ar">&rarr;</span></a>' +
          '<a class="fitres__alt" href="/pages/fit-guide?restart=1">' + (S.fitRetake || 'Retake the quiz') + '</a>';
      } else {
        var left = 3 - answered;
        var leftText = left === 1 ? (S.fitLeftOne || 'You’re 1 question from your suit match.') : (S.fitLeft || 'You’re [count] questions from your suit match.').replace('[count]', left);
        h = '<span class="fitres__ey">' + (S.fitResume || 'Pick up where you left off') + '</span>' +
          '<span class="fitres__t">' + leftText + '</span>' +
          '<a class="deboer-link" href="/pages/fit-guide">' + (S.fitResumeCta || 'Resume the fit quiz') + ' <span class="ar">&rarr;</span></a>';
      }
      var wrap = document.createElement('div');
      wrap.className = 'fitres';
      wrap.innerHTML = '<div class="fitres__in">' + h + '</div>';
      el.parentNode.replaceChild(wrap, el);
    });
  }

  // Size-consult gate (rev 6; API rev 2026-08-28). On wetsuit PDPs
  // (product-info[data-consult="wetsuit"]) intercept the first add-to-cart with a
  // "have you confirmed your size?" interstitial. Remembered per session. Also
  // exposed as window.deboer.consult.ask({name, fitUrl, fitEmail}, cb) so inline
  // add-to-cart surfaces (the ProAm add-ons page's racing-suit cards) can run the
  // same gate before they add — cb(action) fires only when the shopper proceeds.
  function consultGate() {
    var host = document.querySelector('[data-consult="wetsuit"]');
    var ack = false;
    try { ack = sessionStorage.getItem('deboer_consult_ack') === '1'; } catch (e) {}
    var modal = null, pendingBtn = null, pendingCb = null, ctx = {};
    function productName() {
      if (ctx.name) return ctx.name;
      var h = document.querySelector('.buy__title');
      return h ? h.textContent.trim() : (document.title.split('—')[0] || 'a deboer wetsuit').trim();
    }
    function fitUrl() { return ctx.fitUrl || (host && host.getAttribute('data-fit-url')) || '/pages/fit-guide'; }
    function mailLink() {
      // Subject is translated (the customer sees it); the body stays English — it lands
      // with the internal fit team.
      var em = ctx.fitEmail || (host && host.getAttribute('data-fit-email')) || 'info@deboerswim.com';
      var subject = (S.consultMailSubject || 'Size check — [product]').replace('[product]', productName());
      var body = 'Hi deboer Experience Team,\n\nPlease confirm my size before I order.\n\n' +
        'Gender: \nHeight (cm): \nWeight (kg): \nChest circumference (cm): \n' +
        'Model considering: ' + productName() + '\n' +
        'Full-body photo (in trisuit or swimwear): attached\n\nThanks!';
      return 'mailto:' + em + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }
    function baseBody() {
      return '<span class="cgate__ey">' + (S.gateEyebrow || 'One quick check') + '</span>' +
        '<h3>' + (S.gateHeading || 'Have you confirmed your size?') + '</h3>' +
        '<p>' + (S.gateBody || 'Wetsuit fit is exact — height, weight and chest, not t-shirt size. Suits ordered without a size consult can’t be size-exchanged, and returns carry a $40 fee. Thirty seconds now saves the round-trip.') + '</p>' +
        '<div class="cgate__btns">' +
          '<button class="deboer-btn deboer-btn--ink" data-act="ok" type="button">' + (S.gateOk || 'Yes — I’ve been sized') + '</button>' +
          '<div class="cgate__row"><a class="deboer-btn deboer-btn--ghost" href="' + fitUrl() + '">' + (S.gateQuiz || '60-sec quiz') + '</a><button class="deboer-btn deboer-btn--ghost" data-act="capture" type="button">' + (S.gateEmail || 'Email a photo') + '</button></div>' +
        '</div>' +
        '<button class="cgate__skip" data-act="skip" type="button">' + (S.gateSkip || 'Add anyway →') + '</button>';
    }
    // Rev 7 (2026-08-31): "Email a photo" used to be a bare mailto: — 1% of gate
    // interactions and no way to know whether the mail was ever sent. It now
    // opens an in-modal capture (email + height / weight / chest) that posts to
    // the monitor's form relay (#deboer-forms + info@, Mailchimp tag
    // fit-consult) and fires a real generate_lead {lead_type: fit_consult}.
    // The photo mailto survives as the secondary link underneath.
    function selectedSize() {
      var el = document.querySelector('.product-form__input input[type="radio"]:checked, variant-selects select');
      return el ? String(el.value || '').slice(0, 20) : '';
    }
    function captureBody() {
      var lab = function (key, fallback, name, extra) {
        return '<label class="cgate__lab"><span>' + (S[key] || fallback) + '</span><input name="' + name + '" ' + extra + '></label>';
      };
      return '<span class="cgate__ey">' + (S.gateEyebrow || 'One quick check') + '</span>' +
        '<h3>' + (S.gateCapHeading || 'Send us your numbers') + '</h3>' +
        '<p>' + (S.gateCapBody || 'Height, weight and chest — the Experience Team replies with your size within one business day.') + '</p>' +
        '<form class="cgate__form" novalidate>' +
          lab('gateCapEmail', 'Email', 'email', 'type="email" required autocomplete="email" inputmode="email"') +
          '<div class="cgate__nums">' +
            lab('gateCapHeight', 'Height (cm)', 'height_cm', 'type="number" inputmode="numeric" min="120" max="230"') +
            lab('gateCapWeight', 'Weight (kg)', 'weight_kg', 'type="number" inputmode="decimal" step="0.5" min="30" max="200"') +
            lab('gateCapChest', 'Chest (cm)', 'chest_cm', 'type="number" inputmode="numeric" min="60" max="160"') +
          '</div>' +
          '<label class="cgate__opt"><input type="checkbox" name="optin" value="yes"><span>' + (S.gateCapOptin || 'Also send me fit tips and restock news') + '</span></label>' +
          '<p class="cgate__err" hidden>' + (S.gateCapError || 'Add a valid email so we can reply.') + '</p>' +
          '<div class="cgate__btns"><button class="deboer-btn deboer-btn--ink" type="submit">' + (S.gateCapSend || 'Send my numbers') + '</button></div>' +
        '</form>' +
        '<p class="cgate__alt"><a href="' + mailLink() + '">' + (S.gateCapPhoto || 'Prefer to email a full-body photo?') + '</a></p>' +
        '<button class="cgate__skip" data-act="back" type="button">' + (S.gateCapBack || '← Back') + '</button>';
    }
    function sentBody() {
      return '<span class="cgate__ey">' + (S.gateEyebrow || 'One quick check') + '</span>' +
        '<h3>' + (S.gateCapSentHeading || 'Sent — we’ll reply within one business day') + '</h3>' +
        '<p>' + (S.gateCapSentBody || 'Look for an email from the deboer Experience Team with your size. You can keep shopping meanwhile.') + '</p>' +
        '<div class="cgate__btns"><button class="deboer-btn deboer-btn--ink" data-act="continue" type="button">' + (S.gateCapContinue || 'Add to cart and keep going') + '</button></div>' +
        '<button class="cgate__skip" data-act="done" type="button">' + (S.gateCapDone || 'Done') + '</button>';
    }
    function showCapture() {
      var bd = modal.querySelector('.cgate__bd');
      bd.innerHTML = captureBody();
      var form = bd.querySelector('.cgate__form');
      var email = form.querySelector('input[name="email"]');
      setTimeout(function () { try { email.focus(); } catch (e) {} }, 30);
      email.addEventListener('input', function () { form.querySelector('.cgate__err').hidden = true; });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = (email.value || '').trim();
        var err = form.querySelector('.cgate__err');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { err.hidden = false; email.focus(); return; }
        err.hidden = true;
        var fields = { email: val, product: productName().slice(0, 120) };
        var size = selectedSize(); if (size) fields.size_selected = size;
        ['height_cm', 'weight_kg', 'chest_cm'].forEach(function (k) {
          var v = (form.querySelector('input[name="' + k + '"]').value || '').trim();
          if (v) fields[k] = v.slice(0, 10);
        });
        fields.optin = form.querySelector('input[name="optin"]').checked ? 'yes' : 'no';
        beacon('/beacon/form', { form: 'fit-consult', page: location.pathname.slice(0, 200), host: location.hostname, fields: fields });
        track('consult_gate', { action: 'email', surface: ctx.surface || 'pdp' });
        track('generate_lead', { lead_type: 'fit_consult', item: fields.product });
        // They engaged with sizing — don't re-gate this session.
        ack = true;
        try { sessionStorage.setItem('deboer_consult_ack', '1'); } catch (e) {}
        bd.innerHTML = sentBody();
      });
    }
    function build() {
      if (modal) { modal.remove(); modal = null; }   // links are baked per product — rebuild each open
      modal = document.createElement('div');
      modal.className = 'cgate';
      modal.innerHTML = '<div class="cgate__card"><button class="cgate__x" type="button" aria-label="' + (S.close || 'Close') + '">×</button><div class="cgate__bd">' + baseBody() + '</div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal || e.target.classList.contains('cgate__x')) { close(); return; }
        var a = e.target.closest ? e.target.closest('a[href]') : null;
        if (a) { track('consult_gate', { action: a.getAttribute('href').indexOf('mailto:') === 0 ? 'email' : 'quiz', surface: ctx.surface || 'pdp' }); return; }
        var btn = e.target.closest ? e.target.closest('[data-act]') : null;
        var act = btn ? btn.getAttribute('data-act') : null;
        if (act === 'ok' || act === 'skip') proceed(act);
        else if (act === 'capture') showCapture();
        else if (act === 'back') modal.querySelector('.cgate__bd').innerHTML = baseBody();
        else if (act === 'continue') proceed('email', true);
        else if (act === 'done') { proceeded = true; close(); }
      });
      // Esc handling + focus trap live in deboer.dialog (opened per show).
    }
    var proceeded = false;
    function hide() {
      if (modal) { modal.classList.remove('show'); document.body.style.overflow = ''; }
      // Any close that wasn't a proceed() is an abandon — X, overlay, or Esc.
      if (!proceeded) { track('consult_gate', { action: 'dismissed', surface: ctx.surface || 'pdp' }); pendingCb = null; }
    }
    function open() {
      build();
      proceeded = false;
      track('consult_gate', { action: 'shown', surface: ctx.surface || 'pdp' });
      modal.classList.add('show'); document.body.style.overflow = 'hidden';
      window.deboer.dialog.open(modal.querySelector('.cgate__card'), { onClose: hide });
    }
    function close() { if (modal) window.deboer.dialog.close(modal.querySelector('.cgate__card')); }
    function proceed(act, quiet) {
      ack = true;
      proceeded = true;
      // quiet: the capture already tracked its 'email' action on submit.
      if (!quiet) track('consult_gate', { action: act || 'ok', surface: ctx.surface || 'pdp' });
      try { sessionStorage.setItem('deboer_consult_ack', '1'); } catch (e) {}
      close();
      if (pendingCb) { var cb = pendingCb; pendingCb = null; cb(act); return; }
      var btn = pendingBtn || document.querySelector('.product-form__submit');
      if (btn) btn.click();
    }
    window.deboer.consult = {
      acked: function () { return ack; },
      ask: function (opts, cb) {
        if (ack) { cb('acked'); return; }
        ctx = opts || {};
        pendingBtn = null;
        pendingCb = cb;
        open();
      }
    };
    if (!host) return;
    document.addEventListener('click', function (e) {
      if (ack) return;
      var t = e.target.closest && e.target.closest('.product-form__submit, .sbuy__btn');
      if (!t) return;
      ctx = {};
      pendingBtn = t.classList.contains('sbuy__btn') ? document.querySelector('.product-form__submit') : t;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }, true);
  }

  // Sticky add-to-cart bar (rev 6). Shows a compact buy bar once the main
  // add-to-cart button scrolls out of view. Clicking it clicks the real button.
  function stickyBuy() {
    // No sticky buy bar when nothing can be bought — the sold-out panel is the CTA.
    if (document.querySelector('.inv-cta--product_sold_out')) return;
    var add = document.querySelector('.product-form__submit');
    if (!add || !('IntersectionObserver' in window)) return;
    // A PDP fit swap does info.replaceWith(node), which detaches the button we
    // were observing. The old guard bailed out here whenever a bar already
    // existed, leaving the observer pointed at a node no longer in the document
    // — the bar simply stopped appearing. Re-arm against the current button
    // instead of returning.
    var existing = document.querySelector('.sbuy');
    if (existing) {
      if (existing._sbuyIO) {
        existing._sbuyIO.disconnect();
        existing._sbuyIO.observe(add);
      }
      return;
    }
    var nmEl = document.querySelector('.buy__title');
    var nm = nmEl ? nmEl.textContent.trim() : (document.title.split('—')[0] || '').trim();
    var prEl = document.querySelector('.buy__price .price');
    var pr = prEl ? prEl.textContent.trim().split(/\s+/)[0] : '';
    var imEl = document.querySelector('.gal__stage-img.on') || document.querySelector('.gal__stage-img');
    var bar = document.createElement('div');
    bar.className = 'sbuy';
    bar.innerHTML = '<div class="sbuy__in">' +
      (imEl ? '<span class="sbuy__img"><img src="' + imEl.src + '" alt="" /></span>' : '') +
      '<span class="sbuy__nm">' + nm + '</span>' +
      '<span class="sbuy__sz"></span>' +
      '<span class="sbuy__pr">' + pr + '</span>' +
      '<button class="sbuy__btn" type="button">' + (S.addToCart || 'Add to cart') + '</button>' +
    '</div>';
    document.body.appendChild(bar);
    // Resolve the real button at click time, not at build time — the captured
    // reference goes stale the moment the buy panel is replaced by a fit swap,
    // and a click on a detached button silently does nothing.
    bar.querySelector('.sbuy__btn').addEventListener('click', function () {
      var live = document.querySelector('.product-form__submit');
      if (live) live.click();
    });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { bar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    bar._sbuyIO = io;
    io.observe(add);
  }

  // Background video layer for hero sections — client half of
  // snippets/deboer-bg-media.liquid. The poster <img> underneath is the LCP
  // element and nothing here may compete with it, so the markup ships with no
  // src at all and this attaches one only after window load, only once the
  // section is in view, and only if the client opts in below. Every failure
  // path leaves the poster on screen, so the worst case is today's site.
  var bgvLoaded = document.readyState === 'complete';
  var bgvPending = [];
  if (!bgvLoaded) {
    window.addEventListener('load', function () {
      bgvLoaded = true;
      bgvPending.splice(0).forEach(function (el) { el.arm(); });
    });
  }

  // Phones are gated off by default: it's where the bytes hurt most and where
  // the hero crops so hard the motion barely reads. Sections opt in per-use.
  function bgvAllowed(el) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c) {
      if (c.saveData) return false;
      if (/(^|-)2g$/.test(c.effectiveType || '')) return false;
    }
    if (window.innerWidth < 861 && el.dataset.mobile !== 'true') return false;
    return true;
  }

  class DeboerBgVideo extends HTMLElement {
    connectedCallback() {
      if (this.booted) return;
      this.booted = true;
      this.video = this.querySelector('video');
      if (!this.video || !this.dataset.src) return;
      // No IntersectionObserver means no way to know when we're on screen —
      // stay on the poster rather than autoplaying something off-screen.
      if (!('IntersectionObserver' in window)) return;
      if (!bgvAllowed(this)) return;
      if (bgvLoaded) this.arm(); else bgvPending.push(this);
    }
    arm() {
      if (this.armed) return;
      this.armed = true;
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          en.target.inView = en.isIntersecting;
          if (en.isIntersecting) en.target.start(); else en.target.stop();
        });
      }, { rootMargin: '200px 0px' });
      this.io.observe(this);
    }
    // Inside a carousel the inactive slides keep their box and stay in the
    // viewport — IntersectionObserver reports them as intersecting even though
    // they're visibility:hidden. Without this every slide would download its
    // clip at once. `visibility` inherits, so reading it off this element
    // already reflects a hidden ancestor.
    //
    // On the FIRST paint that read is correct, but a carousel transitions
    // visibility, so during a slide change getComputedStyle still returns the
    // outgoing value and the check comes out exactly backwards. A carousel
    // therefore calls setActive() to state which slide is live; once it has,
    // that answer wins and the CSS is never consulted again.
    isHidden() {
      if (this.forcedActive === true) return false;
      if (this.forcedActive === false) return true;
      return getComputedStyle(this).visibility === 'hidden';
    }
    setActive(on) {
      this.forcedActive = !!on;
      if (on) { if (this.inView) this.start(); } else this.stop();
    }
    start() {
      if (this.dead || document.hidden || this.isHidden()) return;
      this.wantPlay = true;
      var v = this.video;
      if (!v.src) {
        var src = this.dataset.src;
        if (window.innerWidth < 861 && this.dataset.srcMobile) src = this.dataset.srcMobile;
        // Set muted as a property, not just the attribute — some browsers
        // check the property when deciding whether autoplay is permitted.
        v.muted = true;
        v.addEventListener('playing', function () {
          this.parentNode.classList.add('is-playing');
          // Once per element: what share of eligible sessions actually see motion.
          track('hero_video_play', { item: (src.split('/').pop() || '').split('?')[0] });
        }.bind(v), { once: true });
        v.addEventListener('error', function () { this.dead = true; this.classList.remove('is-playing'); }.bind(this), { once: true });
        v.src = src;
      }
      var p = v.play();
      // Autoplay refusal is not an error here — the poster is already correct.
      // The success path re-checks wantPlay: a carousel can rotate this slide
      // away while play() is still resolving, and without this the promise
      // would win the race and leave an off-screen clip running.
      if (p && p.then) {
        p.then(function () { if (!this.wantPlay) v.pause(); }.bind(this), function () {});
      }
    }
    // pause() on an already-paused video is a no-op, so this stays unconditional
    // rather than guarding on .paused — the guard was the race.
    stop() { this.wantPlay = false; if (this.video) this.video.pause(); }
    // Re-evaluate after something outside changes our visibility: the tab going
    // to the background (decoding off-screen is real battery cost), or a
    // carousel advancing a slide.
    visibility() {
      if (document.hidden || this.isHidden()) this.stop();
      else if (this.inView) this.start();
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); this.stop(); }
  }
  if ('customElements' in window && !customElements.get('deboer-bg-video')) {
    customElements.define('deboer-bg-video', DeboerBgVideo);
    document.addEventListener('visibilitychange', function () {
      document.querySelectorAll('deboer-bg-video').forEach(function (el) {
        if (typeof el.visibility === 'function') el.visibility();
      });
    });
  }

  // Audience intelligence. One canonical key (aud: wetsuit | pool | proam |
  // nitro | team) plus interest flags (int: race | cold), inferred only from
  // signals the visitor already gave us: the fit-guide's discipline answer,
  // pages only certain people reach, and the topic of the campaign that
  // brought them here. Persisted in localStorage, announced to the pixel as
  // audience_set exactly once per change, and stamped onto the cart as
  // attributes so orders carry the answer without any cookie in the loop.
  // The tri/open-water question is settled upstream: both buy the same
  // wetsuits through the same quiz branch, so they are ONE audience here.
  var AUD_VALUES = ['wetsuit', 'pool', 'proam', 'nitro', 'team'];
  function audState() {
    try {
      var s = JSON.parse(localStorage.getItem('deboer_aud') || 'null');
      if (s && s.aud && s.int) return s;
    } catch (e) {}
    return { aud: [], int: [] };
  }
  function audience() {
    var st = audState();
    var before = JSON.stringify(st);
    function add(kind, v) { if (st[kind].indexOf(v) === -1) st[kind].push(v); }

    var fit = null;
    try { fit = JSON.parse(localStorage.getItem('deboer_fit') || 'null'); } catch (e) {}
    if (fit && fit.discipline === 'tri') add('aud', 'wetsuit');
    if (fit && fit.discipline === 'swim') add('aud', 'pool');

    var p = location.pathname;
    if (p.indexOf('/pages/pro-am') !== -1) add('aud', 'proam');
    if (p.indexOf('/pages/our-team') !== -1) add('aud', 'team');
    if (p.indexOf('/pages/cold-water') !== -1) { add('aud', 'wetsuit'); add('int', 'cold'); }
    if (p.indexOf('/collections/triathlon-racing') !== -1) add('aud', 'wetsuit');
    // The club portals render on several pages — the section marker is the
    // signal, not the path.
    if (document.querySelector('[class*="deboer-tp"]')) add('aud', 'nitro');

    // Campaign topics only set interest flags — audience membership needs a
    // first-party signal (emails get forwarded; a click is not an identity).
    var m = /(?:^|[?&])utm_campaign=\d{6}-[a-z]+-([a-z0-9-]+)/.exec(location.search);
    if (m) {
      if (m[1].indexOf('race') !== -1) add('int', 'race');
      if (m[1].indexOf('cold') !== -1) add('int', 'cold');
    }

    st.aud = st.aud.filter(function (v) { return AUD_VALUES.indexOf(v) !== -1; });
    if (JSON.stringify(st) !== before) {
      try { localStorage.setItem('deboer_aud', JSON.stringify(st)); } catch (e) {}
      // The pixel turns this into the GA4 user property `audience`, so every
      // later event slices by it — fire only on change to keep it one hit.
      track('audience_set', { audience: st.aud.join(','), interests: st.int.join(',') });
    }

    // Cart attribute stamp — the exact-tier bridge: attributes ride the cart
    // into the order, where reporting reads them without GA4 in the loop.
    // Once per session per distinct value; skipped until a cart exists so we
    // never mint empty carts for read-only visits.
    var attrs = {};
    if (st.aud.length) attrs.deboer_aud = st.aud.join(',');
    if (st.int.length) attrs.deboer_int = st.int.join(',');
    if (fit && fit.q3) attrs.deboer_quiz = quizAttr(fit);
    var sig = JSON.stringify(attrs);
    if (sig === '{}' || document.cookie.indexOf('cart=') === -1) return;
    var done = null;
    try { done = sessionStorage.getItem('deboer_aud_sig'); } catch (e) {}
    if (done === sig) return;
    fetch((window.routes && routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).then(function (r) {
      if (r.ok) { try { sessionStorage.setItem('deboer_aud_sig', sig); } catch (e) {} }
    }).catch(function () {});
  }

  // ---- quiz → customer bridge (docs/EMAIL-AUTOMATIONS.md §1.2-B) ----
  // The fit quiz lives only in localStorage; these two hooks carry it onto the
  // records that sync to Mailchimp: the cart attribute (→ order → worker) and the
  // contact[tags] hidden input on every customer capture form (→ lead contact).
  var QUIZ_GENDER = { men: 'm', women: 'w' };
  // Cart attribute: `<q3>:<size|->:<gender m|w|->` — always three fields so the
  // worker can split without guessing which one is missing.
  function quizAttr(fit) {
    return fit.q3 + ':' + (fit.size || '-') + ':' + (QUIZ_GENDER[fit.gender] || '-');
  }
  function fitState() {
    try {
      var f = JSON.parse(localStorage.getItem('deboer_fit') || 'null');
      if (f && typeof f === 'object') return f;
    } catch (e) {}
    return null;
  }
  // Pure: existing tag string + quiz + audience → merged, de-duplicated tag string.
  // Vocabulary is the §1.2 one: `quiz:<discipline>-<gender>-<q3>` (full words,
  // e.g. quiz:tri-women-fjord40) and `aud:<wetsuit|pool|proam|nitro|team>`.
  var TAGS_MAX = 255;
  function leadTags(existing, fit, aud) {
    var tags = String(existing || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var added = [];
    function add(t) { if (tags.indexOf(t) === -1 && t.length < 64) { tags.push(t); added.push(t); } }
    if (fit && fit.done && fit.discipline && fit.gender && fit.q3) {
      add('quiz:' + [fit.discipline, fit.gender, fit.q3].join('-').toLowerCase().replace(/[^a-z0-9:-]/g, ''));
    }
    (aud || []).forEach(function (a) { if (AUD_VALUES.indexOf(a) !== -1) add('aud:' + a); });
    var out = tags.join(',');
    // Tags on the customer form ride a plain text field — keep it sane.
    if (out.length > TAGS_MAX) return { value: String(existing || ''), added: [] };
    return { value: out, added: added };
  }
  function quizTagBridge() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.querySelector) return;
      var input = f.querySelector('input[name="contact[tags]"]');
      if (!input) return;
      var r = leadTags(input.value, fitState(), audState().aud);
      if (!r.added.length) return;
      input.value = r.value;
      track('quiz_tag_attached', { tags: r.added.join(',') });
    }, true);
  }
  window.deboer.quizAttr = quizAttr;
  window.deboer.leadTags = leadTags;

  // Document-level features that bind one global listener / scan the page — run once.
  function initOnce() { rookieMode(); fitResume(); consultGate(); stickyBuy(); audience(); quizTagBridge(); }

  if (document.readyState !== 'loading') { init(); initOnce(); }
  else document.addEventListener('DOMContentLoaded', function () { init(); initOnce(); });

  // Theme editor: re-scan when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
